<section class="background-color-nearwhite">
    <div class="container login-container">
        <h1 [innerHTML]="'login.title' | translate"></h1>
        <p *ngIf="hasLoginInfoSpecialAccess$ | async" class="info-note" [innerHTML]="'login.infoSpecialAccess' | translate"></p>
        <p class="large" [innerHTML]="'login.intro' | translate"></p>
        <div class="inner-wrapper">
            <a
                class="desktop forgot-password"
                [routerLink]="linkForgotPassword"
                da-link
                *ngIf="showForgotPassword$ | async"
                icon="drg-icon-arrow_right"
                ><span [innerHTML]="'login.forgotPassword' | translate"></span
            ></a>
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="login-wrapper">
                <div
                    class="form-group"
                    [class.active]="hasFocusUsername || hasValue(f.username)"
                    [class.hasvalue]="!hasFocusUsername && hasValue(f.username)"
                >
                    <label
                        for="username"
                        [class.active]="hasFocusUsername || hasValue(f.username)"
                        [class.hasvalue]="!hasFocusUsername && hasValue(f.username)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'login.username' | translate"></span></span>
                        <input
                            formControlName="username"
                            id="username"
                            (focus)="hasFocusUsername = true"
                            (blur)="hasFocusUsername = false"
                            type="text"
                        />
                    </label>
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required" [innerHTML]="'login.usernameRequired' | translate"></div>
                        <div *ngIf="f.username.errors.pattern" [innerHTML]="'login.emailFormat' | translate"></div>
                    </div>
                </div>
                <div
                    class="form-group"
                    [class.active]="hasFocusPassword || hasValue(f.password)"
                    [class.hasvalue]="!hasFocusPassword && hasValue(f.password)"
                >
                    <label
                        for="password"
                        [class.active]="hasFocusPassword || hasValue(f.password)"
                        [class.hasvalue]="!hasFocusPassword && hasValue(f.password)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'login.password' | translate"></span></span>
                        <input
                            formControlName="password"
                            id="password"
                            (focus)="hasFocusPassword = true"
                            (blur)="hasFocusPassword = false"
                            type="password"
                        />
                    </label>
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required" [innerHTML]="'login.passwordRequired' | translate"></div>
                    </div>
                </div>
            </div>
            <div *ngIf="notAUniqueEmailAddress$ | async" class="error-message not-unique-email" [innerHTML]="'login.notAUniqueEmailAddress.error' | translate"></div>
            <div *ngIf="notAUniqueEmailAddress$ | async" class="login-wrapper">
                <div
                    class="form-group"
                    [class.active]="hasFocusFirstName || hasValue(f.firstName)"
                    [class.hasvalue]="!hasFocusFirstName && hasValue(f.firstName)"
                >
                    <label
                        for="firstName"
                        [class.active]="hasFocusUsername || hasValue(f.firstName)"
                        [class.hasvalue]="!hasFocusUsername && hasValue(f.firstName)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'login.firstName' | translate"></span></span>
                        <input
                            formControlName="firstName"
                            id="firstName"
                            (focus)="hasFocusFirstName = true"
                            (blur)="hasFocusFirstName = false"
                            type="text"
                        />
                    </label>
                    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                        <div *ngIf="f.firstName.errors.required" [innerHTML]="'login.passwordRequired' | translate"></div>
                    </div>
                </div>
                <div
                    class="form-group"
                    [class.active]="hasFocusLastName || hasValue(f.lastName)"
                    [class.hasvalue]="!hasFocusLastName && hasValue(f.lastName)"
                >
                    <label
                        for="lastName"
                        [class.active]="hasFocusLastName || hasValue(f.lastName)"
                        [class.hasvalue]="!hasFocusLastName && hasValue(f.lastName)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'login.lastName' | translate"></span></span>
                        <input
                            formControlName="lastName"
                            id="lastName"
                            (focus)="hasFocusLastName = true"
                            (blur)="hasFocusLastName = false"
                            type="lastName"
                        />
                    </label>
                    <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                        <div *ngIf="f.lastName.errors.required" [innerHTML]="'login.passwordRequired' | translate"></div>
                    </div>
                </div>
            </div>

            <div class="form-group button-wrapper">
                <label class="checkboxlabel" *ngIf="showRememberMe$ | async">
                    <input
                        type="checkbox"
                        id="remember"
                        [formControlName]="'remember'"
                        (change)="onCheckboxChange($event.target.checked)"
                    />
                    <label for="remember" class="remember-me" [innerHTML]="'login.rememberMe' | translate"></label>
                </label>

                <div class="mobile forgot-password">
                    <a [routerLink]="linkForgotPassword" da-link *ngIf="showForgotPassword$ | async" icon="drg-icon-arrow_right"
                        ><span [innerHTML]="'login.forgotPassword' | translate"></span
                    ></a>
                </div>

                <div class="inner-wrapper">
                    <a href="javascript:;" class="cancel button secondary" (click)="cancel()">
                        <span *ngIf="isCheckout" [innerHTML]="'login.skip' | translate"></span>
                        <span *ngIf="!isCheckout" [innerHTML]="'login.cancel' | translate"></span>
                    </a>
                    <button [disabled]="loading" class="button primary">
                        <span [innerHTML]="'login.submit' | translate"></span>
                    </button>
                </div>
            </div>
            <div *ngIf="showError$ | async" class="error-message" [innerHTML]="'login.error' | translate"></div>
            <div *ngIf="showError401$ | async" class="error-message" [innerHTML]="'login.errorInvalidEmailOrPassword' | translate"></div>
        </form>
    </div>
</section>

<ng-template #notAUniqueEmailAddressPopUp>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="notAUniqueEmailAddressModal"></ng-container>
    </div>
</ng-template>
<ng-template #notAUniqueEmailAddressModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'login.notAUniqueEmailAddress.title' | translate"></h3>
                <p [innerHTML]="'login.notAUniqueEmailAddress.text' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button primary" da-link (click)="closeModal()" [innerHTML]="'login.notAUniqueEmailAddress.agree' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
